import React, { Dispatch, ReactNode, SetStateAction } from 'react';
import ReactDOM from 'react-dom';
import Modal from '../Modal/Modal';

export interface IPortal {
  children?: ReactNode;
  setOpen?: Dispatch<SetStateAction<boolean>>;
  domNode?: HTMLElement | null;
  background?: boolean;
  scrollLock?: boolean;
  focusLock?: boolean;
  scrollIsolation?: boolean;
  onClose?: () => void;
  key?: string;
}

const Portal: React.FunctionComponent<IPortal> = ({
  children,
  setOpen = () => {},
  domNode,
  background = false,
  scrollLock = false,
  scrollIsolation = false,
  focusLock = false,
  key,
}) => {
  return ReactDOM.createPortal(
    <Modal
      background={background}
      focusLock={focusLock}
      scrollLock={scrollLock}
      scrollIsolation={scrollIsolation}
      onCloseRequest={() => setOpen(false)}
    >
      {children}
    </Modal>,
    domNode || document.body,
    key,
  );
};

Portal.displayName = 'Portal';

export default Portal;
